<template>
  <div class="container">
    <div class="header-menu">
      <a class="header-menu-item"
         v-for="menuItem in menuItems"
         :key="menuItem.text"
         :href="menuItem.src"
         :class="{ active: menuItem.active }"
      >
        {{ menuItem.text }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'HeaderMenu',
    data () {
        return {
            menuItems: [
                { text: 'Projekt', src: 'https://www.linguasnapp.uni-hamburg.de/projekt.html' },
                { text: 'Karte', src: 'https://www.linguasnapp.uni-hamburg.de/karte.html', active: true },
                { text: 'Forschung', src: 'https://www.linguasnapp.uni-hamburg.de/forschung.html' },
                { text: 'Veranstaltungen', src: 'https://www.linguasnapp.uni-hamburg.de/veranstaltungen.html' },
                { text: 'Berichte', src: 'https://www.linguasnapp.uni-hamburg.de/berichte.html' },
                { text: 'Team', src: 'https://www.linguasnapp.uni-hamburg.de/team.html' },
            ],
        };
    },
};
</script>

<style scoped>
.header-menu {
  padding: 0 20px;
  margin-top: 2px;
}

.header-menu-item {
  text-decoration: none;
  color: #333;
  font-size: 25px;
  font-family: TheSansUHH-Caps, sans-serif;
  font-weight: 600;
}

.header-menu-item.active {
  color: #027bcb;
}

.header-menu-item:not(:first-child) {
  margin-left: 44.5px;
}

@media (max-width: 910px) {
  .header-menu {
    display: none;
  }
}
</style>
